import classes from './Avatar.module.css';
import profileIcon from '../../../assets/profiles/profile1.svg';

type Props = {
  variant?: 'profile' | 'initals';
  profilePic?: string;
  isSquared?: boolean;
  width?: number;
  height?: number;
  initials?: string;
};

const Avatar: React.FC<Props> = ({
  variant = 'profile',
  profilePic,
  isSquared,
  width,
  height,
  initials,
}) => {
  return (
    <div
      className={[
        classes.container,
        ...(variant === 'initals' ? [classes.initailsContainer] : []),
      ].join(' ')}
    >
      {variant === 'profile' ? (
        <img
          className={`${isSquared ? classes.avatarSquared : classes.avatarRounded}`}
          src={profilePic ?? profileIcon}
          alt="avatar"
          width={width ?? 42}
          height={height ?? 42}
        />
      ) : (
        <p>{initials}</p>
      )}
    </div>
  );
};

export default Avatar;
